(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(79650);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ImageItemList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _components_NextImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5621);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);




const ImageItem = (param)=>{
    let { header , content , image , className , step  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: "mb16 mb10-md ph4 ph0-md ".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NextImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                src: image.src,
                height: image.height,
                width: image.height,
                alt: ""
            }),
            Number.isInteger(step) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "darkGreen ttu font-im",
                children: i18n.t("Step {{number}}", {
                    number: step
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-cm fs28 fs20-md lh12 mt2 mb3 mb1-md gray800 maxw18-md",
                children: header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "lh14 fs16-md font-ir gray600 maxw25 maxw16-md",
                children: content
            })
        ]
    });
};
const ImageItemList = (param)=>/*#__PURE__*/ {
    let { items , rows =1 , itemClassName ="" , showSteps =false  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "df jcsb fdc-md ".concat(rows > 1 && "fw"),
        children: items.map((item, key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageItem, {
                // @ts-expect-error TS2322: Type 'number | false' is not assignable to type 'number | undefined'.
                step: showSteps && key + 1,
                ...item,
                className: "".concat(itemClassName, " ").concat(rows === 2 && "w50p w100p-md")
            }, key))
    });
};


/***/ }),

/***/ 25:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69468);
/* harmony import */ var _utils_cloneChildren__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91048);





const getTransitionStyles = (state)=>({
        entering: {
            opacity: 0
        },
        entered: {
            opacity: 1
        },
        exiting: {
            opacity: 1
        },
        exited: {
            opacity: 0
        },
        unmounted: {
            opacity: 0
        }
    })[state];
const cloneChildrenWithStyles = memoizee__WEBPACK_IMPORTED_MODULE_1___default()((state, children, duration)=>(0,_utils_cloneChildren__WEBPACK_IMPORTED_MODULE_3__/* .cloneChildren */ .v)(children, (param)=>{
        let { props  } = param;
        return {
            style: {
                transition: "opacity ".concat(duration, "ms ease-in-out"),
                ...getTransitionStyles(state),
                ...props.style || {}
            }
        };
    }));
const Fade = (param)=>{
    let { duration =150 , children , timeout =0 , ...transitionProps } = param;
    const transitionRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_transition_group__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        nodeRef: transitionRef,
        timeout: timeout,
        ...transitionProps,
        children: (state)=>cloneChildrenWithStyles(state, children, duration)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(Fade));


/***/ }),

/***/ 34559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ImageGrid; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45602);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var src_components_common_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93932);
/* harmony import */ var src_components_common_ImageItemList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36578);
/* harmony import */ var src_components_v5_V5Comp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63575);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40367);
/* harmony import */ var src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52299);









const ImageGrid = ()=>{
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_6__/* .useTypedSelector */ .ix)((state)=>state.config);
    const bookingUrl = src_components_common_constants__WEBPACK_IMPORTED_MODULE_3__/* .v5Pages.locations */ .Td.locations;
    const imageHeight = isMobile ? 100 : 190;
    const itemList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>[
            {
                header: i18n.t("Book same day appointments"),
                content: i18n.t("Primary, urgent, and virtual care visits on YOUR schedule."),
                image: {
                    src: "home/illustrated-list/01",
                    height: imageHeight
                }
            },
            {
                header: i18n.t("Chat with your health team"),
                content: i18n.t("Get treated for a range of symptoms & conditions right from your smartphone."),
                image: {
                    src: "home/illustrated-list/02",
                    height: imageHeight
                }
            },
            {
                header: i18n.t("Prescriptions at your doorstep"),
                content: i18n.t("Get your medications sent straight to your chosen pharmacy or to your door—whatever works for you."),
                image: {
                    src: "home/illustrated-list/03",
                    height: imageHeight
                }
            },
            {
                header: i18n.t("All your health in one place"),
                content: i18n.t("Access your medical charts, complete records, and test results immediately."),
                image: {
                    src: "home/illustrated-list/04",
                    height: imageHeight
                }
            }
        ], [
        i18n.lang,
        imageHeight
    ]);
    const imageStyle = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>({
            right: 0,
            top: "-25%"
        }), []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "learn-more",
        className: "pv40 pv16-md ph8 maxw85 ma",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-csb lh12 fs48 fs24-md lh14-md mb16 mb8-md dif",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ni18n__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            "A friendlier healthcare experience,",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                className: "db di-md darkerYellow",
                                children: [
                                    "without",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "pos-r zIndex1",
                                        children: [
                                            "the membership fees.",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_7__/* .V5Image */ .dZ, {
                                                alt: "",
                                                style: imageStyle,
                                                src: "home/word-circle",
                                                className: "op5 pos-a maxw20-md dn-md zIndex-1"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_v5_V5Comp__WEBPACK_IMPORTED_MODULE_5__/* .Btn */ .un, {
                href: bookingUrl,
                bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_8__.gray800,
                className: "mb24 mb8-md fs14-f db-f event-pdwXAy focus-bsDarkBlue3",
                children: i18n.t("Book an Appointment")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_ImageItemList__WEBPACK_IMPORTED_MODULE_4__/* .ImageItemList */ .T, {
                rows: 2,
                items: itemList
            })
        ]
    });
};


/***/ }),

/***/ 94612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40367);
/* harmony import */ var src_useMediaQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57974);
/* harmony import */ var src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52299);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93932);
/* harmony import */ var _V5Comp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63575);








const Insurances = ()=>{
    const backgroundImage = (0,src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_5__/* .useV5ImgSrc */ .eH)("home/insurances/01");
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)((state)=>state.config);
    const imageSource = backgroundImage;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const isSm = (0,src_useMediaQuery__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("sm");
    const showSm = isSm || isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        "aria-labelledby": "insurance-heading",
        className: "".concat(showSm ? "pv16 pv8-md" : "pt32 pb120 pv20-sm", " bgnr bgcov bg-gray100"),
        style: {
            backgroundImage: showSm ? "" : "url(".concat(imageSource, ")"),
            backgroundPosition: "80% 50%"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "maxw85 ph8 ".concat(isMobile ? "minh0" : "minh52", " ma"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "maxw48",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            id: "insurance-heading",
                            className: "op1 gray800 mb4 mb2-lg mt0 fs12 lh18 font-ml ls1 ttu",
                            children: i18n.t("Insurance and pricing")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            className: "mb4 fs28-md lh12 maxw30-md font-cm fs40 db maxw40-xl",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ni18n__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                                children: [
                                    "We accept all major insurance plans.",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                        className: "darkBlue fsn",
                                        children: "No subscriptions or membership fees."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_V5Comp__WEBPACK_IMPORTED_MODULE_7__/* .Btn */ .un, {
                            href: _common_constants__WEBPACK_IMPORTED_MODULE_6__/* .v5Pages.insurance */ .Td.insurance,
                            className: "event-pUU1qz brd2nc-f pv3-f brd-black-f black-f fs12-f mb8",
                            bg: "transparent",
                            "aria-label": i18n.t("Learn More about insurance and pricing"),
                            children: i18n.t("Learn more")
                        })
                    ]
                })
            }),
            showSm && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_5__/* .V5Image */ .dZ, {
                className: "w100p",
                src: "home/insurances/01-mobile",
                alt: i18n.t("We accept AARP, United Healthcare, Blue Shield of California and many more. Easily scan your insurance card in our mobile app.")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Insurances);


/***/ }),

/***/ 79650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/_services/featureFlagConstants.ts
var featureFlagConstants = __webpack_require__(72714);
// EXTERNAL MODULE: ./src/_services/featureFlags.ts
var featureFlags = __webpack_require__(30660);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/_services/api.ts + 2 modules
var api = __webpack_require__(95832);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
;// CONCATENATED MODULE: ./src/utils/formatNumbers.ts
var RoundMode;
(function(RoundMode) {
    RoundMode[RoundMode["OFF"] = 0] = "OFF";
    RoundMode[RoundMode["UP"] = 1] = "UP";
    RoundMode[RoundMode["DOWN"] = 2] = "DOWN";
})(RoundMode || (RoundMode = {}));
const roundFloat = function(num, digits) {
    let mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : RoundMode.OFF;
    const mult = parseInt("1".concat("0".repeat(digits)));
    const multipliedNum = Math.abs(num * mult);
    // @ts-expect-error TS7006: Parameter 'result' implicitly has an 'any' type.
    const finishResult = (result)=>result / mult * (num < 0 ? -1 : 1);
    switch(mode){
        case RoundMode.UP:
            return finishResult(Math.ceil(multipliedNum));
        case RoundMode.DOWN:
            return finishResult(Math.floor(multipliedNum));
        default:
            return finishResult(Math.round(multipliedNum));
    }
};
const millionToDecimal = function(n) {
    let digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return roundFloat(Number(Math.abs(Number(n)) / 1.0e6), digits, RoundMode.DOWN);
};

// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/Home/CovidStats.tsx










const CovidStats = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { isMobile  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const backgroundImage = "home/covid-stats/01";
    const data = api/* defaultCovidStats */._y;
    const bgImg = backgroundImage;
    const gradients = isMobile ? [
        {
            background: "linear-gradient(315def, rgba(0,0,0,0) 0%, ".concat(palette.gray800, " 80%")
        },
        {
            background: "linear-gradient(90deg, ".concat(palette.gray800, " 0%, rgba(0,0,0,0) 100%")
        }
    ] : [
        {},
        {}
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "aria-labelledby": "covid-heading",
        style: gradients[0],
        className: "contrast-tbt",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "visually-hidden",
                id: "covid-heading",
                children: i18n.t("Our Covid Initiatives")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: gradients[1],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pv36 pv16-md gray100 pos-r bg-gray200",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                            src: bgImg,
                            layout: "fill",
                            objectFit: "cover",
                            quality: "70",
                            objectPosition: "50% 0",
                            alt: "",
                            className: "contrast-op0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "maxw85 ma ph8 pos-r",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb80 pb24-md",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                            className: "brdn pl0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "dib font-mb ttu fs12 mb8 lh17 white-md maxw15-md",
                                                    children: i18n.t("Captain najera, LA Fire dept, dodger stadium vaccination site:")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "db fs40 fs28-md font-cb maxw40 mb8 mb4-md lh12 white-md",
                                                    children: i18n.t("In order to make this work well, we have a collaborative effort with Carbon Health... Without them this wouldn’t work.")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                            bg: "transparent",
                                            href: _constants/* v5Pages.coronavirus */.Td.coronavirus,
                                            className: "event-2DmDMC gray100-f fs12-f brd2nc-f brd-gray100 font-ib-f mt4 pv3-f",
                                            children: i18n.t("See all COVID-19 Initiatives")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                    className: "dgc gtr2a gafc df-sm jcsb-sm fdc-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            className: "font-mb ttu fs12 mb8 mb3-md",
                                            children: i18n.t("tests conducted")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "fs40 fs28-md font-cb maxw20 maxw15-md mb8 mb12-md mis0",
                                            children: i18n.t("{{number}} million +", {
                                                number: millionToDecimal(_constants/* isCI */.yg ? 1400000 : data.totalCovidTests, 2)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            className: "font-mb ttu fs12 mb8 mb3-md",
                                            children: i18n.t("vaccines administered")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "fs40 fs28-md font-cb maxw20 maxw15-md mb8 mb12-md mis0",
                                            children: i18n.t("{{number}} million +", {
                                                number: millionToDecimal(_constants/* isCI */.yg ? 1400000 : data.totalVaxCount, 2)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            className: "font-mb ttu fs12 mb8 mb3-md",
                                            children: i18n.t("UCSF Digital Health Awards")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "fs40 fs28-md font-cb maxw20 maxw15-md lh12-md mb8 mb0-md mis0",
                                            children: i18n.t("COVID Patriot Best Delivery & Decision Support Award")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Home_CovidStats = (CovidStats);

// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
// EXTERNAL MODULE: ./src/queries/useFetchCareEntries.ts
var useFetchCareEntries = __webpack_require__(37239);
// EXTERNAL MODULE: ./src/utils/getFeaturedCares.ts + 2 modules
var getFeaturedCares = __webpack_require__(69547);
// EXTERNAL MODULE: ./src/components/v5/CareEntryRow/index.tsx + 9 modules
var CareEntryRow = __webpack_require__(25561);
// EXTERNAL MODULE: ./src/components/v5/Reason/CareDiscoverySearch/careDiscoveryAnalytics.ts
var careDiscoveryAnalytics = __webpack_require__(9121);
// EXTERNAL MODULE: ./src/components/v5/Reason/CareDiscoverySearch/CareDiscoverySearch.tsx + 16 modules
var CareDiscoverySearch = __webpack_require__(57852);
;// CONCATENATED MODULE: ./src/components/v5/Home/Hero.tsx










const Hero = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const featuredCareSlugs = (0,getFeaturedCares/* useFeaturedCareSlugs */.Tx)();
    const defaultResultsQuery = (0,useFetchCareEntries/* useFetchCareEntries */.S)(featuredCareSlugs);
    const isHSm = (0,useMediaQuery/* default */.Z)("md", {
        isHeight: true
    });
    const isWXl = (0,useMediaQuery/* default */.Z)("xl");
    const is13inchScreen = isHSm && isWXl;
    const viewId = (0,careDiscoveryAnalytics/* useSendDefaultResultsViewedEvent */.Vt)({
        results: defaultResultsQuery.data,
        isLoading: !defaultResultsQuery.isSettled
    });
    const widget = (0,react.useMemo)(()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "md:bg-white md:rounded-xl md:p-6 flex flex-col p-4 pt-6 md:justify-between md:min-w-[27rem]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch/* default */.Z, {
                defaultResults: defaultResultsQuery.data,
                defaultResultsLoadingCount: !defaultResultsQuery.isSettled ? featuredCareSlugs.length : undefined,
                dialogTitle: i18n.t("Book an Appointment"),
                defaultListRowVariant: CareEntryRow/* CareEntryRowVariant.SM */.s.SM,
                viewId: viewId,
                hideRegionSelector: true,
                hideDefaultListController: true,
                hideDefaultListGradient: true,
                doNotReportDefaultResultsOnMount: true
            })
        }), [
        defaultResultsQuery.data,
        defaultResultsQuery.isSettled,
        featuredCareSlugs.length,
        i18n,
        viewId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(is13inchScreen ? "ph12" : "ph8", " pt36-md pb40 pb18-md pos-r contrast-tbb ").concat(is13inchScreen ? "pt20" : "pt40"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                        src: "home/hero",
                        quality: "80",
                        priority: true,
                        objectFit: "cover",
                        objectPosition: "0 0",
                        layout: "fill",
                        className: "obpl contrast-op0",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "df maxw85 ma jcsb aife pos-r",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "white maxw30 mb2 lh12 font-cm fs24-md",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                                            children: [
                                                "Making good health accessible ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                    className: "lightYellow fsn",
                                                    children: "to all."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fs28 fs18-md white font-cm lh14",
                                        children: i18n.t("Book same day appointments.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fs28 fs18-md white font-cm mb8 lh14",
                                        children: i18n.t("No subscriptions.")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block w-[460px]",
                                children: widget
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:hidden",
                children: widget
            })
        ]
    });
};
/* harmony default export */ var Home_Hero = (/*#__PURE__*/react.memo(Hero));

// EXTERNAL MODULE: ./src/components/v5/Home/ImageGrid.tsx
var ImageGrid = __webpack_require__(34559);
// EXTERNAL MODULE: ./src/components/v5/OtherProviders.tsx + 1 modules
var OtherProviders = __webpack_require__(86203);
// EXTERNAL MODULE: ./src/components/v5/Reason/Download.tsx + 1 modules
var Download = __webpack_require__(67018);
// EXTERNAL MODULE: ./src/utils/schemaUtils.ts
var schemaUtils = __webpack_require__(13521);
// EXTERNAL MODULE: ./src/components/v5/Home/Insurances.tsx
var Insurances = __webpack_require__(94612);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./src/components/v5/Nav/useNavState.ts
var useNavState = __webpack_require__(13284);
// EXTERNAL MODULE: ./src/components/v5/Services.tsx + 1 modules
var Services = __webpack_require__(9142);
// EXTERNAL MODULE: ./src/components/v5/TestimonialSlider.tsx
var TestimonialSlider = __webpack_require__(97455);
// EXTERNAL MODULE: ./src/constants/practiceIds.ts
var practiceIds = __webpack_require__(34557);
;// CONCATENATED MODULE: ./src/pages/index.tsx



















const Index = ()=>{
    const { title , description  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config , metadata  } = param;
        return {
            ...config,
            ...metadata
        };
    });
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    // @ts-expect-error TS7006: Parameter 'd' implicitly has an 'any' type.
    const doctorFilter = (d)=>d.specialties.includes("Primary Care") && d.practiceId === practiceIds/* PracticeId.CARBON */.I.CARBON;
    const schemas = [
        {
            "@context": "http://schema.org",
            "@type": "Organization",
            url: schemaUtils/* schema.website */.fK.website,
            logo: schemaUtils/* schema.logo */.fK.logo,
            contactPoint: [
                {
                    "@type": "ContactPoint",
                    telephone: schemaUtils/* schema.address.telephone */.fK.address.telephone,
                    contactType: "billing support",
                    areaServed: "US"
                }
            ]
        },
        {
            "@context": "http://schema.org/",
            "@type": "MedicalOrganization",
            name: "Carbon Health Primary Care",
            url: schemaUtils/* schema.website */.fK.website,
            address: {
                "@type": "PostalAddress",
                addressCountry: schemaUtils/* schema.address.addressCountry */.fK.address.addressCountry,
                addressLocality: schemaUtils/* schema.address.addressLocality */.fK.address.addressLocality,
                addressRegion: schemaUtils/* schema.address.addressRegion */.fK.address.addressRegion,
                postalCode: schemaUtils/* schema.address.postalCode */.fK.address.postalCode,
                streetAddress: schemaUtils/* schema.address.streetAddress */.fK.address.streetAddress,
                email: schemaUtils/* schema.address.email */.fK.address.email,
                telephone: schemaUtils/* schema.address.telephone */.fK.address.telephone
            },
            logo: {
                "@type": "ImageObject",
                image: schemaUtils/* schema.logo */.fK.logo,
                contentUrl: schemaUtils/* schema.logo */.fK.logo
            }
        },
        {
            "@context": "http://schema.org",
            "@type": "WebSite",
            name: schemaUtils/* schema.name */.fK.name,
            headline: schemaUtils/* schema.title */.fK.title,
            image: schemaUtils/* schema.logo */.fK.logo,
            description: schemaUtils/* schema.description */.fK.description,
            publisher: {
                "@type": "Organization",
                logo: {
                    "@type": "ImageObject",
                    url: schemaUtils/* schema.logo */.fK.logo
                }
            }
        }
    ].map((s)=>JSON.stringify(s));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: title || i18n.t("Carbon Health | Modern Primary & Urgent Care"),
        pageDescription: description || i18n.t("Carbon Health Provides Smart, hassle-free Primary & Urgent Care. Book same day Adult & Pediatric appointments instantly."),
        style: {
            "--brandColor": palette.mint,
            "--brandColorDarker": palette.darkerMint
        },
        navTheme: useNavState/* NavTheme.LIGHT */.Xm.LIGHT,
        schemas: schemas,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGrid/* ImageGrid */.E, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Services/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {
                trackingLabel: "Home"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_CovidStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherProviders/* default */.Z, {
                filter: doctorFilter,
                coordinate: {
                    latitude: 39.5501,
                    longitude: -105.7821
                },
                radius: 2000
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Insurances/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlider/* default */.Z, {})
        ]
    });
};
Index.getInitialProps = async (param)=>{
    let { req , store , query , pathname  } = param;
    await (0,featureFlags/* fetchFeatureFlags */.Vw)({
        [featureFlagConstants/* FeatureFlag.CARE_DISCOVERY_TOPICS_SEARCH_ENABLED */.T.CARE_DISCOVERY_TOPICS_SEARCH_ENABLED]: true,
        [featureFlagConstants/* FeatureFlag.GROWTH_DISCOVERY_SEARCH_AVAILABILITY_ENABLED */.T.GROWTH_DISCOVERY_SEARCH_AVAILABILITY_ENABLED]: true
    }, {
        dispatch: store.dispatch,
        req,
        query,
        overrideAttribute: {
            pathname
        }
    });
    return {};
};
/* harmony default export */ var pages = (Index);


/***/ }),

/***/ 91048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ cloneChildren; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);

const cloneChildren = (children, getNewProps)=>react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (child, i)=>{
        if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) {
            return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, getNewProps(child, i));
        }
        return child;
    });


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,1439,598,6282,2122,7018,7852,9142,5095,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);